import {getCountryCode} from '@/helpers/shadcn/utils'
import {SALES_ORG_STORAGE_KEY} from '@/hooks/useCountryProductTabs'
import {COUNTRY_CODES} from '@/utils/constants/countryConstants'

// Add authentication token to every request
export const authInterceptor = config => {
  const countryCode = getCountryCode()
  config.headers.countryCode = countryCode ?? 'MX'
  // Temporarily hardcoding salesOrg as CO03 until the UI is fully developed.
  if (countryCode === COUNTRY_CODES.CO) {
    config.headers.salesOrg = sessionStorage.getItem(SALES_ORG_STORAGE_KEY) || 'CO03'
  }
  const token = localStorage.getItem('msalAccessToken')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}

// Attach the interceptor to an Axios instance
export const attachAuthInterceptor = axiosInstance => {
  axiosInstance.interceptors.request.use(authInterceptor, error => Promise.reject(new Error(error)))
}
